<template>
  <div>
    <v-btn flat @click="load_previous_day">&lt; Previous day</v-btn>
  	<div v-for="(events, date) in grouped_events" style="margin-top: 20px">
   		<h3>{{format_date_with_weekday(date)}}</h3>

      <template v-if="!tile_dashboard">
   		 <v-list two-line dense>
   			  <template v-for="(list,index) in sorted(events)">
            <template v-for="(event, i) in list">
              <dashboard-event :event="event" :key="event.uuid"></dashboard-event>
              <v-divider inset style="border-color: rgba(0, 0, 0, .03)" v-if="i + 1 < list.length"></v-divider>
            </template>
            <v-divider v-if="index + 1 < Object.values(events).length"></v-divider>
   			  </template>
	   	 </v-list>
     </template>

<!--
     <template v-if="tile_dashboard">
      <v-container fluid grid-list-xs style="padding: 0;">
        <v-layout row wrap>
          <template v-for="(list,index) in sorted(events)">
            <v-flex xs3>
              <dashboard-tile-event :events="list" :key="index"></dashboard-tile-event>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
     </template>

-->
  	</div>
    <v-btn flat @click="load_next_day">Next day &gt;</v-btn>

    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add_event"><v-icon>add</v-icon></v-btn>

    <v-btn class="black" v-if="$is_admin()" :outline="filter_own_events" style="top: 90px; right: 600px;" dark fab small fixed top right @click="filter_own_events = !filter_own_events"><v-icon>filter</v-icon></v-btn>
<!--    <v-btn class="black" v-if="$is_admin()" :outline="tile_dashboard" style="top: 90px; right: 650px;" dark fab small fixed top right @click="tile_dashboard = !tile_dashboard"><v-icon>dashboard</v-icon></v-btn>-->



    <v-toolbar :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; max-width: 500px;" class="hidden-xs-only">

      <v-text-field color="deep-orange" prepend-icon="search" v-model="event_search" ref="search_field" clearable hide-details single-line></v-text-field>
      <v-card style="position: absolute; top: 48px; left: 0px; width: 500px; margin-top: 0px; padding-top: 0px;" class="elevation-5">
        <event-search style="overflow: auto; max-height: 500px;" :search="event_search"></event-search>
      </v-card>
    </v-toolbar>
  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import strftime from 'strftime';
import EventSearch from './Search'
import Vue from 'vue';
import EventModel from '@/models/event.js'

import DashboardEvent from './Event.vue'
import DashboardTileEvent from './TileEvent.vue'

export default {
  filters: datelib,
  components: {
    DashboardEvent,
    DashboardTileEvent,
    EventSearch,
  },
  data () {
  	var start_date = moment().startOf('day').toDate();
	  var end_date = moment().add(7, 'days').endOf('day').toDate();
    return {
      event_search: "",
      search_menu: false,
    	headers: [],
      channel: undefined,
      events: [],
      grouped_events: [],
      events_by_uuid: {},
      filter_own_events: false,
      tile_dashboard: false,
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },
        states: ["active"]
      },
  	}
  },
  computed: {
  },
  mounted: function() {
    this.$nextTick(function() {
      this.connect_ws();
    });
  },

  watch: {
    "filter_own_events" (newVal, oldVal) {
      var self = this;
      Vue.nextTick(function () {
        self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
      });
    }
  },

  methods: {
    load_previous_day () {
      this.filters.daterange.start = moment(this.filters.daterange.start).subtract(1, 'days');
      this.filterEvents();
    },
    load_next_day () {
      this.filters.daterange.end = moment(this.filters.daterange.end).add(1, 'days');
      this.filterEvents();
    },
    get_grouped_events: function(events) {
      var self = this;
      var ret = {};

      var f_events = events;
      if (self.filter_own_events == true) {
        f_events = _.filter(events, function(event) {
          return EventModel.is_todo_list(event, self.$store.state.account);
        }); 
      }

      _.each(f_events, function(event) {
        var d = moment(event.cached_start_time * 1000).startOf('day').unix();
        if (typeof(ret[d]) == "undefined") ret[d] = {};
        if (typeof(ret[d][event.event_group.uuid]) == "undefined") ret[d][event.event_group.uuid] = [];
        ret[d][event.event_group.uuid].push(event);
      });
      return ret;
    },
    open_add_event () {
      this.$router.push("/dashboard/event_new");
    },
  	format_date (date) {
  		if (date == moment().startOf('day').unix()) return "Today";
  		return datelib.format_date(date);
  	},
    format_date_with_weekday (date) {
      if (date == moment().startOf('day').unix()) return "Today";
      return datelib.format_date_with_weekday(date);
    },
  	sorted(list) {
  		return _.sortBy(list, [function(l) {
        var sorted = _.sortBy(l, [function(o) { return o.cached_start_time; }]);
        return sorted[0].cached_start_time;
      }]);
  	},
  	filterEvents () {
      var _filters = _.cloneDeep(this.filters);
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      if(typeof(_filters.daterange.end) != "undefined") {
        _filters.daterange.end = moment(_filters.daterange.end).endOf('day').unix();
      }
      this.channel.push("filter", _filters);
    },
    is_between_dates(event) {
      var _filters = _.cloneDeep(this.filters);
      var start_date = moment(_filters.daterange.start).startOf('day').unix();
      var end_date = moment(_filters.daterange.end).endOf('day').unix();
      return (event.cached_end_time > start_date && event.cached_start_time < end_date);
    },
    add_event_to_list(event) {
      var self = this;
      if (event.state == "active" && self.is_between_dates(event) ) {
        Vue.set(self.events_by_uuid, event.uuid, event);
      } else {
        Vue.delete(self.events_by_uuid, event.uuid);
      }
    },
  	connect_ws () {
  		var self = this;
	    this.channel = this.$cloudserver.channel("events:all");
  	  this.channel.on("init", function(msg) {
    	  console.log("Dashboard events init", msg);
      	self.filterEvents();
    	});

    	this.channel.on("events", function(msg) {
        console.log("Dashboard events");
        _.each(msg.events, function(event) {
          self.add_event_to_list(event);
        });

        Vue.nextTick(function () {
          self.grouped_events = self.get_grouped_events(msg.events);
        });
        console.log("Events list updated")
    	});
    	this.channel.on("event-update", function(msg) {
      	console.log("Dashboard event update", msg)

        var event = msg.data;
        self.add_event_to_list(event);

        Vue.nextTick(function () {
          self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
        });
    	});
    	this.channel.join();
  	}
  },
  beforeDestroy: function() {
    console.log("Leaving channel DASHBOARD");
    this.channel.off("init");
    this.channel.off("events");
    this.channel.off("event-update");
    this.channel.leave();
  }


}
</script>

<style scoped>

</style>
